import React from 'react';
import { useHistory } from 'react-router-dom';
import DataList from 'commons-ui/src/components/baselist/DataList';
import usePermission from 'commons-ui/src/permission/usePermission';
import { ENTITIES, DEFAULT_PAGINATION } from '../constants';
import { columnConfigs } from './listConfig';
import useSuspiciousService from './useSuspiciousService';
import { makeActionList, makeActionHandler } from '../actions';

const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: DEFAULT_PAGINATION.DEFAULT_PAGE_SIZE
	}
};

const SuspiciousTransactionsList: React.FC = () => {
	const { listRequests } = useSuspiciousService();
	const history = useHistory();
	const { hasPermission } = usePermission();
	const fetchData = async ({ pageDetails }: any) => {
		const data = await listRequests({ pageDetails });
		return data;
	};

	const actions = makeActionList({ hasPermission });
	const getActionHandler = (action: any, params?: any) => makeActionHandler(action, { history, ...params });

	return (
		<DataList
			defaults={DEFAULT_CONFIG}
			fetchData={fetchData}
			columnConfigs={columnConfigs}
			entity={ENTITIES.SUSPICIOUS_TX}
			actions={actions}
			getActionHandler={getActionHandler}
			disablePaginationSelect
		/>
	);
};

export default SuspiciousTransactionsList;
